import { html } from "lit-html"
import { virtual } from "haunted"

const UserRow = virtual(
  ({ name, roles, url }) => html`
    <div class="user filter-result-row cursor-default group">
      <div class="w-full p-5">
        <p>
          <a href=${url}>${name}</a>
        </p>
        ${Object.entries(roles).map(
          ([role, programs]) => html`
            <p class="capitalize">
              ${role}
              ${programs.length !== 0 ? `(${programs.sort().join(", ")})` : ""}
            </p>
          `
        )}
      </div>
      <hr class="filter-result-row-divider" />
    </div>
  `
)

export default UserRow
